import React, { useState, useCallback, useEffect } from 'react';
import block from 'bem-cn';
import { useSelector, useDispatch } from 'react-redux';

import Input from 'components/Input';
import Button from 'components/Button';
import { actions } from '../../redux';
import LanguageDropdownSelector from 'components/LanguageDropdownSelector';

import './Auth.scss';

const Auth = () => {
  const b = block('auth');
  const [userName, changeUserName] = useState('');
  const [password, passwordUserName] = useState('');
  const [disable, setDisable] = useState(true);

  const locale = useSelector(state => state.locale.locale);
  const { isProcess } = useSelector(state => state.auth);
  const dispatch = useDispatch();
  const signIn = useCallback(() => {
    if (!isProcess) {
      dispatch(actions.login(userName, password));
    }
  }, [userName, password, isProcess, dispatch]);

  useEffect(() => {
    if (password.length !== 0 && userName.length !== 0) {
      setDisable(false);
    } else {
      setDisable(true);
    }
  }, [password, userName]);

  return (
    <section className={b()}>
      <div className={b('content')}>
        <div className={b('title')}>
          <span className={b('title-text')}>{locale.agentPlatfrom}</span>
          <span className={b('title-login')}>{locale.login}</span>
        </div>
        <div className={b('form')}>
          <div className={b('input-block')}>
            <div className={b('input-block', 'title')}>{locale.login}</div>
            <Input
              value={userName}
              onChange={e => changeUserName(e.currentTarget.value)}
              placeholder={locale.name}
              size="low"
            />
          </div>
          <div className={b('input-block')}>
            <div className={b('input-block', 'title')}>{locale.password}</div>
            <Input
              value={password}
              onChange={e => passwordUserName(e.currentTarget.value)}
              type="password"
              withEye
              size="low"
              placeholder="●●●●●●●●●●●●"
            />
          </div>
          <div className={b('button')}>
            <Button text={locale.access} callBack={signIn} disabled={disable} />
          </div>
        </div>
        <div className={b('other')}>
          <span>{locale.other}</span>
        </div>
        <div className={b('language-selector')}>
          <LanguageDropdownSelector />
        </div>
      </div>
    </section>
  );
};

export default Auth;
